import { defineStore } from 'pinia'
import api from '@/services/api'
import { useAuthStore } from './auth'


export const useAplicacoesStore = defineStore('aplicacoes', {
  state: () => ({
    authStore: useAuthStore(),
    aplicacoes: []
  }),
  actions: {
    async get() {
        
        const result = await api.get('/aplicacoes', {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        this.aplicacoes = result.data
    },

    async getFichaTecnica(id) {
        
        const result = await api.get(`/aplicacoes/ficha_tecnica/${id}`, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        return result.data
    },

    async add(novaAplicacao) {
        
        if(!novaAplicacao.planoId) delete novaAplicacao.planoId;
        novaAplicacao.numero_usuarios = parseInt(novaAplicacao.numero_usuarios)

        const result = await api.post('/aplicacoes', novaAplicacao, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async delete(aplicacao){

      const result = await api.delete(`/aplicacoes/${aplicacao.id}`, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async update(aplicacao){

      const result = await api.put(`/aplicacoes/${aplicacao.id}`, aplicacao, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async forcarInstall(aplicacao){

      const result = await api.post(`/aplicacoes/forceInstall/${aplicacao.id}`, {}, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },

    


  }
})